export const authTokensStoragKeys = Object.freeze({
    "ACCESS": "Y9ZtYezvplulmCTV",
    "REFRESH": "hRy4lBSoBbM8mv3K",
});